<template>
  <v-menu bottom left offset-y origin="top right" transition="scale-transition" z-index="200">
    <template v-slot:activator="{ attrs, on }">
      <v-btn class="ml-2" min-width="0" text v-bind="attrs" v-on="on">
        <v-badge v-if="notifications.length" color="red" overlap bordered>
          <template v-slot:badge>
            <span>{{ notifications.length }}</span>
          </template>

          <v-icon>mdi-bell</v-icon>
        </v-badge>
        <v-icon v-else>mdi-bell</v-icon>
      </v-btn>
    </template>

    <v-list :tile="false" nav>
      <div v-if="notifications.length">
        <loader class="ms-1" v-if="loadEvent" loading :size="32" block />
        <app-bar-item
          v-for="(n, i) in notifications"
          :key="`item-${i}`"
          :class="{ 'notification-item--disabled': currentEvent === i }"
          class="notification-item"
          @click.stop="showEvent(n, i)"
        >
          <v-list-item-title>
            <b>{{ n.start }}</b> {{ n.title }}
          </v-list-item-title>
        </app-bar-item>
      </div>
      <v-list-item v-else> Уведомлений пока нет</v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
import dayjs from "dayjs";
import Loader from "@/components/Loader";

import customParseFormat from "dayjs/plugin/customParseFormat";
import ScheduleAppointmentDetail from "@/modules/schedule/ScheduleAppointmentDetail.vue";
import { ScheduleRepository } from "@/modules/schedule/schedule.repository.js";

dayjs.extend(customParseFormat);
import { VHover, VListItem } from "vuetify/lib";
export default {
  name: "CoreAppBarNotifications",
  components: {
    Loader,
    AppBarItem: {
      render(h) {
        return h(VHover, {
          scopedSlots: {
            default: ({ hover }) => {
              return h(
                VListItem,
                {
                  attrs: this.$attrs,
                  class: {
                    "black--text": !hover,
                    "white--text secondary elevation-12": hover,
                  },
                  on: { ...this.$listeners },
                  props: {
                    activeClass: "",
                    dark: hover,
                    link: true,
                    ...this.$attrs,
                  },
                },
                this.$slots.default,
              );
            },
          },
        });
      },
    },
  },
  data() {
    return {
      currentEvent: null,
      notifications: [],
      loadEvent: false,
    };
  },
  methods: {
    async loadEvents() {
      try {
        const response = await this.$http.get("/v1/doctor/appointments");
        const responseEvents = (response.data?.data || []).map(el => {
          return {
            title: "Запись на приём",
            start: dayjs(el.start_at, "DD.MM.YYYY HH:mm").format("DD.MM.YY HH:mm"),
            end: null,
            all_day: false,
            originalEvent: el,
          };
        });
        this.notifications = responseEvents;
      } catch (error) {
        console.error(`Ошибка получения данных =>`, error);
      }
    },
    bindSocket(id) {
      this.$echo
        .private(`appointments.${id}`)
        .listen(".appointment.created", () => {
          this.loadEvents();
        })
        .listen(".appointment.updated", () => {
          this.loadEvents();
        })
        .listen(".appointment.deleted", () => {
          this.loadEvents();
        });
    },
    async showEvent(event, index) {
      /**
       * Обработка клика по ивенту
       *
       * @param nativeEvent
       * @param event
       */
      if (event.originalEvent.id) {
        this.currentEvent = index;
        this.loadEvent = true;
        // показать данные записи на прием
        const response = await ScheduleRepository.getAppointment(event.originalEvent.id);
        this.loadEvent = false;
        if (response.success) {
          await this.$dialog.showAndWait(ScheduleAppointmentDetail, {
            width: "600px",
            appointment: response.data.data,
            calendarEvent: event.originalEvent,
          });
          this.currentEvent = null;
        } else {
          this.$dialog.notify.error(response.message);
        }
      }
    },
  },

  async mounted() {
    if (this.$store.getters["auth/getUserId"]) {
      this.loadEvents();
      this.bindSocket(this.$store.getters["auth/getUserId"]);
    }
  },
};
</script>
<style>
.notification-item--disabled {
  pointer-events: none;
}
</style>
